// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"index_wrapper_2Saa4","iFrame":"index_iFrame_1rSzZ","popups":"index_popups_b58dA","popupsMessage":"index_popupsMessage_3YdkI"};